"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetIdInput = exports.StyledCardHeadHorizontal = exports.StyledCardHead = exports.StyledCardCover = exports.StyledCardBody = exports.StyledCard = exports.ContentWrapper = exports.ChildrenWrapper = void 0;
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _StyledIcon = _interopRequireDefault(require("../Icon/StyledIcon"));
var _StyledButton = _interopRequireDefault(require("../Button/StyledButton"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var StyledCardHeadHorizontal = exports.StyledCardHeadHorizontal = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1fi701o-0"
})(["color:", ";zoom:1;margin-bottom:-1px;.title{font-size:", ";font-weight:500;width:70%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block;}.title:only-child{width:100%;}"], function (props) {
  return props.theme.card.head.textColor;
}, function (props) {
  return props.theme.card.head.titleFontSize;
});
var calcBorderColor = (0, _ykbStyledComponents.css)(["", ""], function (props) {
  return props.$borderColor && (0, _ykbStyledComponents.css)(["border-color:", ";box-shadow:0px 2px 15px 0px rgba(0,0,0,0.08);&:hover{border-color:", ";}&:active{border-color:", ";}"], function (props) {
    return props.theme.card.card.borderColor[props.$borderColor].default;
  }, function (props) {
    return props.theme.card.card.borderColor[props.$borderColor].hover;
  }, function (props) {
    return props.theme.card.card.borderColor[props.$borderColor].active;
  });
});
var WidgetIdInput = exports.WidgetIdInput = _ykbStyledComponents.default.input.withConfig({
  componentId: "ykb-ui__sc-1fi701o-1"
})(["position:absolute;width:0px;height:0px;padding:0px;border:none;"]);
var StyledCardHead = exports.StyledCardHead = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1fi701o-2"
})(["height:", ";line-height:", ";color:", ";background:", ";border-bottom:1px solid ", ";padding:", ";border-radius:", ";zoom:1;margin-bottom:-1px;", ";.title{font-size:", ";font-weight:500;width:70%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block;}.title:only-child{width:100%;}.extra{float:right;text-align:right;margin-left:auto;", "{padding:0;margin-bottom:2px;}", "{font-size:24px;}}.extra-left{", "{padding:0;margin-bottom:2px;}", "{font-size:24px;}}"], function (props) {
  return props.theme.card.head.height;
}, function (props) {
  return props.theme.card.head.height;
}, function (props) {
  return props.theme.card.head.textColor;
}, function (props) {
  return props.theme.card.head.backgroundColor;
}, function (props) {
  return props.theme.card.head.borderColor;
}, function (props) {
  return props.theme.card.head.padding;
}, function (props) {
  return props.theme.card.head.borderRadius;
}, calcBorderColor, function (props) {
  return props.theme.card.head.titleFontSize;
}, _StyledButton.default, _StyledIcon.default, _StyledButton.default, _StyledIcon.default);
var StyledCardCover = exports.StyledCardCover = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1fi701o-3"
})(["& > *{display:block;width:100%;height:100%;}& > img{border-radius:", ";}"], function (props) {
  return props.theme.card.cover.borderRadius;
});
var StyledCardBody = exports.StyledCardBody = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1fi701o-4"
})(["padding:", ";zoom:1;", ""], function (props) {
  return props.theme.card.body.padding;
}, function (props) {
  return props.$borderColor && (0, _ykbStyledComponents.css)(["padding:", ";"], function (props) {
    return props.theme.card.body.borderColorPadding;
  });
});
var StyledCard = exports.StyledCard = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1fi701o-5"
})(["padding:", ";background-color:", ";border-radius:", ";font-size:", ";position:relative;-webkit-transition:all 0.3s;transition:all 0.3s;", " ", " ", " ", ";", ""], function (props) {
  return props.theme.card.card.padding;
}, function (props) {
  return props.theme.card.card.backgroundColor;
}, function (props) {
  return props.theme.card.card.borderRadius;
}, function (props) {
  return props.theme.card.card.fontSize;
}, function (props) {
  return props.$hoverable && (0, _ykbStyledComponents.css)(["cursor:pointer;&:hover{box-shadow:", ";border-color:transparent;border-radius:", ";}"], function (props) {
    return props.theme.card.card.hover.boxShadow;
  }, function (props) {
    return props.theme.card.card.borderRadius;
  });
}, function (props) {
  return props.$bordered && (0, _ykbStyledComponents.css)(["border:", ";"], function (props) {
    return props.theme.card.card.bordered.border;
  });
}, function (props) {
  return props.$selected && (0, _ykbStyledComponents.css)(["cursor:pointer;border:", ";", ""], function (props) {
    return props.theme.card.card.selected.border;
  }, function (props) {
    return props.$hoverable && (0, _ykbStyledComponents.css)(["cursor:pointer;&:hover{border:", ";}"], function (props) {
      return props.theme.card.card.selected.border;
    });
  });
}, calcBorderColor, function (props) {
  return props.$isHorizontalMode && (0, _ykbStyledComponents.css)(["display:flex;"]);
});
var ContentWrapper = exports.ContentWrapper = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1fi701o-6"
})(["", ""], function (_ref) {
  var withArrow = _ref.withArrow;
  return withArrow && (0, _ykbStyledComponents.css)(["display:flex;justify-content:space-between;align-items:center;> .card-arrow-icon{color:", ";font-size:", ";margin-left:5px;}"], function (props) {
    return props.theme.card.body.icon.color;
  }, function (props) {
    return props.theme.card.body.icon.size;
  });
});
var ChildrenWrapper = exports.ChildrenWrapper = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1fi701o-7"
})(["width:100%;"]);